<script>
  import Page from '@components/page'
  import Text from '@components/general/text.svelte'
  import Button from '@components/buttons/button.svelte'
  import Image from '@components/general/image.svelte'
  import UpdateForm from '@components/contributors/form.svelte'
  import { Users, Pencil } from 'lucide-svelte'

  let { contributor, other_contributors = [] } = $props()

  let title = $derived(contributor?.name || "Contributor")
  
  let formOpen = $state(false)

</script>

<Page.Layout {title}>

  <Page.Navigation {title} Icon={Users}
    links={[{ href: '/contributors', text: 'Contributors' }]}
    adminActions={[
      { text: "Edit", icon: Pencil, onSelect: () => formOpen = true }
    ]}
  />

  <Page.Content>

    <!-- Hero -->
    <section class="relative rounded-sm shadow-md px-6 pt-18 min-h-[20vh] flex items-end gap-6 overflow-hidden bg-linear-to-tr from-gray-100/80 to-stone-50/60">

      <!-- Decorative icon -->
      <div class="absolute -bottom-4 -right-4 rotate-[-8deg] opacity-[0.07]">
        <Users size={180} strokeWidth={0.75} />
      </div>

      <!-- Avatar -->
      <Image
        src={contributor.image}
        alt={contributor.name}
        text={contributor.name?.charAt(0)}
        class="relative z-10 w-24 h-24 mb-6 rounded-full object-cover border-2 border-white bg-gray-100 text-gray-400 text-2xl shadow-md flex-shrink-0"
      />

      <!-- Name & role -->
      <div class="relative z-10 flex flex-col gap-1 pb-6">
        <Text variant="title" as="h1" text={contributor.name} class="sm:text-3xl" />
        <span class="text-gray-500">{contributor.role || 'Contributor'}</span>
      </div>

    </section>

  </Page.Content>

  <Page.Content>

    {#snippet main()}

      <!-- Bio -->
      <div class="max-w-[70ch]">
        <div class="prose text-gray-600 max-w-none">
          {#if contributor.bio}
            {@html contributor.bio.html}
          {:else}
            <p class="text-gray-400 italic">No bio available.</p>
          {/if}
        </div>
      </div>

    {/snippet}

    {#snippet aside()}

      {#if other_contributors.length > 0}
        <div class="pt-6 flex flex-col gap-3">
          <Text variant="section_title" text="Other Contributors" as="h5" />
          {#each other_contributors as other (other.id)}
            <Button variant="naked" path={`/contributors/${other.id}`} class="flex w-full items-center gap-3 p-2 -mx-2 border border-transparent hover:border-primary-200 hover:bg-primary-50/80">
              <Image src={other.image} alt={other.name} text={other.name?.charAt(0)} class="w-9 h-9 rounded-full object-cover border border-gray-200/70 bg-gray-100 text-gray-400 text-xs flex-shrink-0" />
              <div class="flex flex-col gap-0.5 min-w-0">
                <span class="truncate text-gray-700 font-medium text-sm">{other.name}</span>
                <span class="text-gray-500 text-xs">{other.role || 'Contributor'}</span>
              </div>
            </Button>
          {/each}
        </div>
      {/if}

    {/snippet}

  </Page.Content>

</Page.Layout>


<UpdateForm bind:open={formOpen} contributor={contributor} onClose={() => formOpen = false} />